export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1588192623572-8c669050e943?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxzdGFja2VkJTIwZmlyZXdvb2QlMjBydXN0aWN8ZW58MHx8fHwxNzkyNTgxODExfDA&ixlib=rb-4.1.0&q=85",
    brennholz: "https://customer-assets-0z36b82j.emergentagent.net/job_holz-uckermark/artifacts/e6477841c87996c2_3444C8B9-7814-467B-B220-E01E2FE73DC5.png",
    bauholz: "https://images.pexels.com/photos/12278566/pexels-photo-12278566.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    forst: "https://images.pexels.com/photos/28441065/pexels-photo-28441065.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    holzkunst: "https://images.pexels.com/photos/38127387/pexels-photo-38127387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PHONE = "+49 151 20707720";
export const PHONE_HREF = "tel:+4915120707720";
export const EMAIL = "kischio@yahoo.de";
export const REGIONS = ["Uckermark", "Berlin", "Mecklenburgische Seenplatte", "Mecklenburg-Strelitz"];

export const NOISE_BG =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")";

export function scrollToId(id) {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}


export const ASSETS = {
    logoSmall: "/logo-hero.png",
    logoBanner: "https://customer-assets-0z36b82j.emergentagent.net/job_holz-uckermark/artifacts/488c381731a7603e_D3661A9F-2282-4B21-93B7-6C49722B85DA.png",
    kunst: [
        "/kunst/IMG_3738.jpg",
        "/kunst/IMG_8445.jpg",
        "/kunst/IMG_8444.jpg",
        "/kunst/IMG_3731.jpg",
        "/kunst/IMG_3733.jpg",
        "/kunst/IMG_3734.jpg",
        "/kunst/IMG_3736.jpg",
        "/kunst/IMG_3737.jpg",
    ],
};
